
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/privacy-policy",
      function () {
        return require("private-next-pages/[locale]/privacy-policy/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/privacy-policy"])
      });
    }
  